import { useState, useEffect } from 'react';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
      role="navigation"
      aria-label="Main Navigation"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="flex items-center gap-3 cursor-pointer m-0 p-0" onClick={() => scrollToSection('hero')}>
            <a href="#hero" aria-label="Sri Maruthi Teeth Empire - Home" className="flex items-center gap-3 no-underline">
              <img
                src="https://static.readdy.ai/image/4c54787fd2047152d108467e5113439e/e5fe30b4f26c08cfb369c5b19d957793.png"
                alt="Sri Maruthi Teeth Empire Dental Clinic Logo - Best Dentist Kondapur Hyderabad"
                title="Sri Maruthi Teeth Empire - Best Dental Clinic in Kondapur Hyderabad"
                className="w-16 h-16 object-contain rounded-lg"
                width="64"
                height="64"
              />
              <span className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif', color: isScrolled ? '#0A1F3D' : '#fff' }}>
                Sri Maruthi Teeth Empire
              </span>
            </a>
          </h1>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Home
            </a>
            <a
              href="#overview"
              onClick={(e) => { e.preventDefault(); scrollToSection('overview'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              About
            </a>
            <a
              href="#services"
              onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Services
            </a>
            <a
              href="#testimonials"
              onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Testimonials
            </a>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'
              }`}
            >
              Contact
            </a>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="https://wa.me/918340978930"
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label="Chat on WhatsApp with Sri Maruthi Teeth Empire"
              className="hidden sm:flex items-center gap-2 text-sm font-medium text-white bg-green-500 hover:bg-green-600 px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              WhatsApp
            </a>
            <a
              href="#booking"
              onClick={(e) => { e.preventDefault(); scrollToSection('booking'); }}
              className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Book Appointment
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
